export enum Status {
  Uninitialized,
  InProgress,
  Done,
  Failed
}
